enum CountryEnum {
    CZ = "CZ",
    SK = "SK",
}

export default CountryEnum;
